import { LiveAnnouncer } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  input,
  Input,
  OnChanges,
  output,
  Output,
} from '@angular/core';
import { ONE_TIME_SERVICE } from '@portal/common';
import { ButtonDirective, ServicesListSkeletonComponent } from '@portal/ui-common';
import { isResidentialServiceCode, ServiceCode } from '@shared/ui-service';
import { IconComponent, PluralizeUnitPipe } from '@shared/ui-shared';
import { ServiceListItem } from '../../models/service-list-item.model';
import { ServiceType } from '../../models/service-type.model';
import { GallonToGalPipe } from '../../pipes/gallon-to-gal.pipe';
import { ServicesUnavailableComponent } from '../services-unavailable/services-unavailable.component';

@Component({
  selector: 'csl-service-list',
  standalone: true,
  imports: [
    CommonModule,
    ButtonDirective,
    ServicesListSkeletonComponent,
    ServicesUnavailableComponent,
    IconComponent,
    GallonToGalPipe,
    PluralizeUnitPipe,
  ],
  templateUrl: './service-list.component.html',
  styleUrl: './service-list.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block ',
  },
})
export class ServiceListComponent implements OnChanges {
  private static instanceCount = 0;
  private readonly liveAnnouncer = inject(LiveAnnouncer);

  ServiceType = ServiceType;
  oneTimeService = ONE_TIME_SERVICE;
  readonly headingId = `csl-service-list-heading-${ServiceListComponent.instanceCount++}`;

  isResidentialService(serviceCode: ServiceCode): boolean {
    return isResidentialServiceCode(serviceCode);
  }

  ngOnChanges(): void {
    const count = this.services?.length ?? 0;

    if (this.isLoading || !count) {
      return;
    }

    const kind = this.serviceType$$() === ServiceType.Residential ? 'residential' : 'commercial';
    this.liveAnnouncer.announce(`${count} ${kind} service option${count === 1 ? '' : 's'} ready to review`, 'polite');
  }

  serviceType$$ = input.required<ServiceType>();
  description$$ = input<string>('Select a service option below');

  @Input({ required: true }) isLoading = false;
  @Input({ required: true }) services?: ServiceListItem[] | null = null;

  @Output() selectService = new EventEmitter<ServiceListItem>();
  openCitiesClick = output<string>();
  contactUsClick = output<string>();

  orderService(service: ServiceListItem): void {
    this.selectService.emit(service);
  }
}
